<dx-popup
  [width]="'500px'"
  [(visible)]="showModal"
  [height]="'auto'"
  [showTitle]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
>
  <div class="popup-content">
    <h1 class="title">{{ "SUBSCRIPTIONS.REQUEST-SUBSCRIPTION.TITLE" | translate }}</h1>
    <p class="description">{{ "SUBSCRIPTIONS.REQUEST-SUBSCRIPTION.DESCRIPTION" | translate }}</p>
    <p>{{ "SUBSCRIPTIONS.REQUEST-SUBSCRIPTION.EMAIL-INFO" | translate }}</p>
    <div class="button-container">
      <dx-button 
        [text]="'COMMON.CANCEL' | translate" 
        type="danger"
        stylingMode="contained"
        [width]="'175px'"
        (onClick)="cancel()"
        [disabled]="isSubmitting"
      ></dx-button>
      <dx-button 
        [text]="'SUBSCRIPTIONS.REQUEST-SUBSCRIPTION.SEND-REQUEST' | translate" 
        type="normal"
        stylingMode="contained"
        [width]="'175px'"
        (onClick)="send()"
        [disabled]="isSubmitting"
      ></dx-button>
    </div>
  </div>
</dx-popup>